export const actionTypes = {
  SET_DELIVERY_STATE: 'SET_DELIVERY_STATE',
}
